module.exports = __webpack_public_path__ + "static/media/H.85382516.svg";